import React, { Component } from 'react';
import {setAndGetAttributes} from './FormInputFunctions';
// import Datetime from 'react-datetime';
import moment from 'moment';
import 'moment-timezone';
import 'react-datetime/css/react-datetime.css';
import {getDateFormat, getUserTimeZone} from '../../Utils/UserFunctions';
import {isSet,dateTimeValidation} from '../../Utils/CommonFunctions';
import Wrp from "../../hoc/Wrp/Wrp";
import MomentUtils from '@date-io/moment';
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import {correctSegmentValue, getDefaultValueDateTime, getSegmentPositionsDateTime, isTextDateSegment, shouldPad, applyTextDateSegmentLetter, parseMaskedDateValue, toMaskedDateInputValue, finalizeMaskedDateOnBlur, ensureMaskedInputValue, remaskInputPreservingSegment} from '../../Utils/DateUtils';
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
// cyan lightBlue
import blue from "@material-ui/core/colors/blue";
// import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';


class DateTimePick extends Component {

  constructor() {
      super();
      this.state = {
        dt: moment(),
        setDt: moment(),
        value:''
      };
    }

  fieldOnChangeHandler = (momentObj)=>{
    const {changeHandler,attributes} = this.props;
    if (isSet(momentObj,null)!==null &&   typeof momentObj.format === "function") {
        const outputFormat = (isSet(attributes?.putDateFormat,null)!==null)?attributes?.putDateFormat:getDateFormat('DateTime');
        changeHandler(momentObj.format(outputFormat));
    }else{
      changeHandler(null);
    }
  } 

  dateChange = (moment) => {
    const {changeHandler,attributes} = this.props;
    //let fieldDetail = JSON.parse(this.props.fieldDetails);
    if (typeof moment.format === "function") {
      changeHandler(moment.format(getDateFormat('DateTime')));
      this.setState({value:moment.format(getDateFormat('DateTime'))})
    }else{
      if(dateTimeValidation(moment) === true) {
        changeHandler(moment);
        this.setState({value:moment})

      }
    }      
  } 
  

  render() {
    const {value} = this.props;
    let attr = setAndGetAttributes(this.props);
    const dateFormat = (isSet(attr.getDateFormat,null)!==null)?attr.getDateFormat:getDateFormat('DateTime') || 'YYYY-MM-DDTHH:mm:ss';
    let dispValue = null;
    // if(dateFormat==='UNIX'){
    //   dispValue = (isSet(value,null)!==null)?moment(value).format(getDateFormat('DateTime')):'';
    // }else{
    //   dispValue = (isSet(value,null)!==null)?moment(value, dateFormat, true).format(getDateFormat('DateTime')):'';
    // }
    if(dateFormat==='UNIX'){
      dispValue = (isSet(value,null)!==null)?moment(value):null;
    }else if(isSet(value,null)!==null){
      const parsed = moment(value, [dateFormat, 'YYYY-MM-DDTHH:mm:ss', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss.S', 'YYYY-MM-DD'], true);
      dispValue = parsed.isValid() ? parsed : null;
    }
    const materialTheme = createTheme({
      palette: {
        primary: blue,
      },
    });
    const handleKeyDown = (e) => {
            const input = e.target;
            const key = e.key;
            const format = getDateFormat('DateTime');
            // const separator = format.match(/[^A-Za-z0-9]/)?.[0] || '/';
            const segments = getSegmentPositionsDateTime(format);
            // console.log('segments',segments);
            let cursor = input.selectionStart;
            let value = input.value || getDefaultValueDateTime(format);
            // Keep MMMM/MMM slot open while editing existing values
            {
              const remasked = remaskInputPreservingSegment(value, cursor, format);
              if (value !== remasked.masked) {
                value = remasked.masked;
                input.value = value;
                if (remasked.segment) {
                  cursor = remasked.segment.start;
                }
              } else {
                value = remasked.masked;
              }
            }
      
            const isDigit = /^\d$/.test(key);
            const isLetter = /^[a-zA-Z]$/.test(key);
            const isControl = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key);
            let didPad = false;
            const currentSegment = segments.find(seg => cursor >= seg.start && cursor <= seg.end);
            if (!currentSegment) return;
      
            const segIndex = segments.indexOf(currentSegment);
            const { start: segStart, end: segEnd } = currentSegment;
            const segLength = segEnd - segStart;
            const segVal = value.slice(segStart, segEnd);
            const isTextSegment = isTextDateSegment(currentSegment.part);
      
            if (!isControl && !((isDigit && !isTextSegment) || (isLetter && isTextSegment))) {
              e.preventDefault();
              return;
            }
      
            if (isDigit) {
              e.preventDefault();
      
              let positionInSegment = cursor - segStart;
              let segChars = segVal.split('');
              const isSegmentFullyFilled = !segChars.includes('_') && !segChars.includes(' ');
      
                // 👇 If segment is full, start fresh on first key press
                if (isSegmentFullyFilled && positionInSegment === 0) {
                  segChars = Array(segLength).fill('_');
                }
      
              // Shift left and insert new key at cursor
              segChars.splice(positionInSegment, 0, key);
              segChars = segChars.slice(0, segLength); // Ensure segment length
              const rawUpdated = segChars.join('').replace(/_/g, '');
      
              const segmentType = currentSegment.type;
              const digitsOnly = value.replace(/[^\d]/g, '');
      
              // Auto-pad logic
              if (shouldPad(segmentType, rawUpdated, digitsOnly)) {
                segChars = rawUpdated.padStart(segLength, '0').split('');
              }
      
              let updatedSegment = segChars.join('').padEnd(segLength, '_');
              // const digitsOnly = value.replace(/[^\d]/g, '');
      
              if (shouldPad(currentSegment.part, updatedSegment.replace(/_/g, ''), segChars.join(''))) {
                // updatedSegment = updatedSegment.replace(/_/g, '').padStart(segLength, '0');
                const corrected = correctSegmentValue(currentSegment.part, updatedSegment, digitsOnly);
                updatedSegment = corrected.padEnd(segLength, '_');
                didPad = true;
              }
              // console.log('currentSegment',updatedSegment);
              value = value.slice(0, segStart) + updatedSegment + value.slice(segEnd);
              input.value = value;
      
              const newCursor = segStart + positionInSegment + 1;
      
              queueMicrotask(() => {
                if (didPad && segIndex < segments.length - 1) {
                  // Move to next segment if padding was applied
                  const next = segments[segIndex + 1];
                  input.setSelectionRange(next.start, next.end);
                } else {
                  // const newCursor = segStart + positionInSegment + 1;
                  if (newCursor < segEnd) {
                    input.setSelectionRange(newCursor, newCursor);
                  } else if (segIndex < segments.length - 1) {
                    const next = segments[segIndex + 1];
                    input.setSelectionRange(next.start, next.end);
                  } else {
                    input.setSelectionRange(segStart, segEnd);
                  }
                }
                // if (newCursor < segEnd) {
                //   input.setSelectionRange(newCursor, newCursor);
                // } else if (segIndex < segments.length - 1) {
                //   const next = segments[segIndex + 1];
                //   input.setSelectionRange(next.start, next.end);
                // } else {
                //   input.setSelectionRange(segStart, segEnd);
                // }
              });
      
              // Auto-advances when MMM=3 / MMMM=9 letters; shorter months use ArrowRight
              return;
            }

            if (isLetter && isTextSegment) {
              e.preventDefault();

              const applied = applyTextDateSegmentLetter({
                key,
                cursor,
                selectionEnd: input.selectionEnd,
                value,
                segments,
                currentSegment,
                segIndex,
              });
              value = applied.value;
              input.value = value;

              queueMicrotask(() => {
                input.setSelectionRange(applied.selectionStart, applied.selectionEnd);
              });

              // Auto-advances when MMM=3 / MMMM=9 letters; shorter months use ArrowRight
                 return;
            }
            if (key === 'Backspace') {
              e.preventDefault();
            
              let newValue = value;
              let newCursor = cursor;
            
              const segVal = value.slice(segStart, segEnd);
              const isCleared = /^[_\s]*$/.test(segVal);
            
              if (!isCleared) {
                // Clear only current segment
                const cleared = '_'.repeat(segEnd - segStart);
                newValue = newValue.slice(0, segStart) + cleared + newValue.slice(segEnd);
                newCursor = segStart;
              } else if (segIndex > 0) {
                // If current segment already cleared, move to previous segment
                const prev = segments[segIndex - 1];
                const prevCleared = '_'.repeat(prev.end - prev.start);
                newValue = newValue.slice(0, prev.start) + prevCleared + newValue.slice(prev.end);
                newCursor = prev.start;
              }
            
              input.value = newValue;
            
              queueMicrotask(() => {
                input.setSelectionRange(newCursor, newCursor);
            
                const allCleared = segments.every(seg => /^[_\s]*$/.test(newValue.slice(seg.start, seg.end)));
                if (allCleared) {
                  this.fieldOnChangeHandler(null);
                }
              });
            
              return;
            }
            // if (key === 'Backspace') {
            //   let newValue = value;
            //   let newCursor = cursor;
            //   let currentIndex = segIndex;
    
            //   // Iterate segments backward if already cleared
            //   while (currentIndex >= 0) {
            //     const seg = segments[currentIndex];
            //     const segVal = newValue.slice(seg.start, seg.end);
            //     const isCleared = /^[_\s]*$/.test(segVal);
    
            //     if (!isCleared) {
            //       const cleared = '_'.repeat(seg.end - seg.start);
            //       newValue = newValue.slice(0, seg.start) + cleared + newValue.slice(seg.end);
            //       newCursor = seg.start;
            //       break;
            //     }
            //     currentIndex--;
            //   }
    
            //   input.value = newValue;
            //   requestAnimationFrame(() => {
            //     input.setSelectionRange(newCursor, newCursor);
    
            //     const digitsOnly = newValue.replace(/[^\d]/g, '');
            //     const allCleared = digitsOnly.length === 0;
            //     if (allCleared) {
            //       this.fieldOnChangeHandler(null);
            //     }
            //   });
            //   return;
            // }
      
            if (key === 'ArrowRight' && segIndex < segments.length - 1) {
              e.preventDefault();
              const next = segments[segIndex + 1];
              input.setSelectionRange(next.start, next.end);
              return;
            }
      
            if (key === 'ArrowLeft' && segIndex > 0) {
              e.preventDefault();
              const prev = segments[segIndex - 1];
              input.setSelectionRange(prev.start, prev.end);
              return;
            }
          };
          
        // console.log('segments',getDefaultValue(format));
        
        const handleBlur = (e) => {
          const format = getDateFormat('DateTime');
          const input = e.target;
          if (!input) return;
          const finalized = finalizeMaskedDateOnBlur(input.value, format);
          input.value = finalized.displayValue;
          if (finalized.isValid) {
            const momentDate = finalized.momentDate;
            this.fieldOnChangeHandler?.(momentDate);
          }
        };

        const handleFocusOrClick = (e) => {
          const format = getDateFormat('DateTime');
          const input = e.target;
          
              if (!input.value) {
                input.value = getDefaultValueDateTime(format);
                try {
                  input.setSelectionRange(0, 0);
                } catch (e) {
                  // handle error silently
                }
              } else {
                const cursor = input.selectionStart || 0;
                const remasked = remaskInputPreservingSegment(input.value, cursor, format);
                input.value = remasked.masked;
                try {
                  if (remasked.segment) {
                    input.setSelectionRange(remasked.segment.start, remasked.segment.end);
                  }
                } catch (e) {
                  // handle error silently
                }
              }
        };

    // Use initialFocusedDate so when there is no value, picker opens on current
    // time in user's timezone, but input stays empty until user selects.
    const initialFocusedDate =
      (isSet(dispValue, null) !== null && isSet(dispValue, null) !== '')
        ? dispValue
        : moment.tz(getUserTimeZone());

    return (
      <Wrp>
        <ThemeProvider theme={materialTheme}>
            <MuiPickersUtilsProvider utils={MomentUtils} >
              <KeyboardDateTimePicker
                fullWidth
                keyboard
                clearable
                margin="normal"
                ampm={false}
                defaultValue={null} 
                value={isSet(dispValue,null)}
                 initialFocusedDate={initialFocusedDate}
                // value={(isSet(dispValue,null)!==null  && isSet(dispValue,null)!=='Invalid date')?moment(dispValue, getDateFormat('DateTime'), true):null}//this.state.selectedDate}//attr.value}
                // disablePast
                onChange={this.fieldOnChangeHandler}
                label=""
                // clearable={true}
                InputProps={{
                  ...attr,
                  // className:'form-control',
                  style: {fontSize: '0.8rem',borderTopLeftRadius:'0px',borderBottomLeftRadius:'0px',paddingLeft:'4px' ,width:"auto" , minWidth:'235px' , maxWidtth:'350px' },
                  disableUnderline: true,
                  autoComplete:'off',
                  placeholder: getDateFormat('DateTime'),
                  onFocus:handleFocusOrClick,
                  onBlur:handleBlur,
                  onClick:handleFocusOrClick,
                  onKeyDown:(e)=>{handleKeyDown(e)}
                }}
                // readOnly={readonlyVal} 
                //  variant={'inline'}       
                // showTodayButton 
                format={getDateFormat('DateTime')}
                />
              </MuiPickersUtilsProvider>             
            </ThemeProvider>
      </Wrp>        
    );
  }
}

DateTimePick.defaultProps = {
  isMandatory:false,
  className: 'form-control'
}

export default DateTimePick;